import { ServicesActionsTypes } from "../types/Services.reducer.types";

export function createRequest(values, { setSubmitting }, closePanel, isAdmin?) {
  return {
    type: ServicesActionsTypes.CREATE_REQUEST,
    payload: { values, setSubmitting, closePanel, isAdmin }
  };
}

export function createSuccess(message) {
  return {
    type: ServicesActionsTypes.CREATE_SUCCESS,
    payload: { message }
  };
}

export function createFailure(message) {
  return {
    type: ServicesActionsTypes.CREATE_FAIL,
    payload: { message }
  };
}

export function editRequest(values, { setSubmitting }, closePanel, isAdmin?) {
  return {
    type: ServicesActionsTypes.EDIT_REQUEST,
    payload: { values, setSubmitting, closePanel, isAdmin }
  };
}

export function editSuccess(message) {
  return {
    type: ServicesActionsTypes.EDIT_SUCCESS,
    payload: { message }
  };
}

export function editFailure(message) {
  return {
    type: ServicesActionsTypes.EDIT_FAIL,
    payload: { message }
  };
}

export function listRequest(filter?, isAdmin?) {
  return {
    type: ServicesActionsTypes.LIST_REQUEST,
    payload: { filter, isAdmin }
  };
}

export function listSuccess({ list }) {
  return {
    type: ServicesActionsTypes.LIST_SUCCESS,
    payload: { list }
  };
}

export function listFailure() {
  return {
    type: ServicesActionsTypes.LIST_FAIL
  };
}

export function dismissMessage() {
  return {
    type: ServicesActionsTypes.DISMISS_MESSAGE
  };
}
